/* tslint:disable */
/* eslint-disable */
/**
 * openapi.yml
 * オンラインCE API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ElectrolyzerInput } from './ElectrolyzerInput';
import {
    ElectrolyzerInputFromJSON,
    ElectrolyzerInputFromJSONTyped,
    ElectrolyzerInputToJSON,
} from './ElectrolyzerInput';
import type { ElectrolyzerOutput } from './ElectrolyzerOutput';
import {
    ElectrolyzerOutputFromJSON,
    ElectrolyzerOutputFromJSONTyped,
    ElectrolyzerOutputToJSON,
} from './ElectrolyzerOutput';

/**
 * 電解槽情報
 * @export
 * @interface Electrolyzer
 */
export interface Electrolyzer {
    /**
     * 
     * @type {ElectrolyzerInput}
     * @memberof Electrolyzer
     */
    input?: ElectrolyzerInput;
    /**
     * 
     * @type {ElectrolyzerOutput}
     * @memberof Electrolyzer
     */
    output?: ElectrolyzerOutput;
}

/**
 * Check if a given object implements the Electrolyzer interface.
 */
export function instanceOfElectrolyzer(value: object): value is Electrolyzer {
    return true;
}

export function ElectrolyzerFromJSON(json: any): Electrolyzer {
    return ElectrolyzerFromJSONTyped(json, false);
}

export function ElectrolyzerFromJSONTyped(json: any, ignoreDiscriminator: boolean): Electrolyzer {
    if (json == null) {
        return json;
    }
    return {
        
        'input': json['input'] == null ? undefined : ElectrolyzerInputFromJSON(json['input']),
        'output': json['output'] == null ? undefined : ElectrolyzerOutputFromJSON(json['output']),
    };
}

export function ElectrolyzerToJSON(value?: Electrolyzer | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'input': ElectrolyzerInputToJSON(value['input']),
        'output': ElectrolyzerOutputToJSON(value['output']),
    };
}

